@if (releaseCalendarData()) {
  <h4 class="info-page-total-expenses">
    Общие расходы за
    {{ releaseCalendarSelectedOptions()?.monthName }}
    {{ releaseCalendarSelectedOptions()?.year }}:
    {{ totalExpenses() }}
  </h4>
}
<button
  mat-stroked-button
  color="primary"
  type="button"
  (click)="visibleGroups.set([])"
>
  Свернуть все
</button>
<div class="info-page-btns">
  <div class="info-page-zoom-wrapper">
    <mat-select
      class="info-page-zoom-select"
      [value]="currentZoomOption()"
      (selectionChange)="currentZoomOption.set($event.value)"
    >
      @for (zoomOption of ZOOM_OPTIONS; track zoomOption) {
        <mat-option [value]="zoomOption">
          {{ zoomOption }}%
        </mat-option>
      }
    </mat-select>
  </div>
  <button
    mat-stroked-button
    color="primary"
    type="button"
    (click)="handleOpenModal()"
  >
    {{ btnText() }}
  </button>
</div>
